import type { LucideIcon } from "lucide-react"
import { type ReactNode } from "react"

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description: string
  action?: ReactNode
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-12 text-center">
      <div className="border-fig-card-border bg-fig-card-bg shadow-fig-card mb-4 flex size-16 items-center justify-center rounded-2xl border">
        <Icon size={28} className="text-fig-text-placeholder" />
      </div>
      <h3 className="text-fig-text-primary mb-1.5 text-[16px] font-semibold">
        {title}
      </h3>
      <p className="text-fig-text-inactive max-w-[260px] text-[14px] leading-normal">
        {description}
      </p>
      {action && <div className="mt-5">{action}</div>}
    </div>
  )
}
